import { useEffect, useState } from "react";
import { useShellHost } from "@/shell-handle/ShellHostProvider";
import type { MfeErrorState } from "@/shell-handle/mfeError";
import { ErrorPage } from "@/pages/ErrorPage/ErrorPage";
import { Button, Styles } from "@/shared/coralreef";
import { DESKTOP_DEV } from "@/single-spa-config/apps";

export function MfeErrorOverlay() {
  const host = useShellHost();
  const [err, setErr] = useState<MfeErrorState | null>(
    host.mfeError.state.get(),
  );

  useEffect(() => host.mfeError.state.subscribe(setErr), [host]);

  if (!err) return null;
  return (
    <div
      data-testid="mfe-error-overlay"
      data-mfe-app={err.appName}
      data-mfe-message={err.message}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999,
        background: Styles.Colours.darkestBlue,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        overflowY: "auto",
      }}
    >
      <ErrorPage />
      {DESKTOP_DEV && (
        // ErrorPage's Refresh signs out; in live-mfe dev the usual cause is
        // the MFE dev server mid-restart, and a plain reload keeps the session.
        <div
          data-testid="mfe-error-reload"
          title={`${err.appName}: ${err.message}`}
        >
          <Button
            content="Reload (keep session)"
            appearance="hollow"
            onClick={() => window.location.reload()}
          />
        </div>
      )}
    </div>
  );
}
